enum FormOptionDisclaimer {
  Warn = 'Warn',
  Info = 'Info',
  Error = 'Error',
}
export default FormOptionDisclaimer;
